<template>
    <Slide :style="{ width: 'auto' }">
        <a href="#" class="nav-menu-card" :class="{ active: activeCategory === category.name }"
            @click.prevent="selectCategory(category.name)">
            <div class="left-nav-thumb" 
                :class="{ 'left-nav-thumb-text': !category.image_url && showFirstLetter, 'left-nav-no-image-text': !category.image_url && showNoImageText}">
                <template v-if="category.image_url">
                    <img :src="$customImageUtil.getImageUrl(category.image_url)" :alt="category.name" />
                </template>
                <template v-else>
                    <span v-if="showFirstLetter">{{ category.name?.charAt(0).toUpperCase() }}</span>
                    <span v-if="showNoImageText">{{ t('noImage') }}</span>
                </template>
            </div>
            <span>{{ category.name }}</span>
        </a>
    </Slide>
</template>

<script setup>
import { computed, defineEmits, defineProps, ref } from 'vue';
import { Slide } from 'vue3-carousel';
import { useI18n } from 'vue-i18n';
import { useCategoryStore } from '@/stores/category';

defineProps({
    category: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['update:category']);

const { t } = useI18n();

const { getActiveCategory } = useCategoryStore();

const activeCategory = computed(() => getActiveCategory());

const showFirstLetter = ref(false);
const showNoImageText = ref(true);

const selectCategory = (categoryName) => {
    emit('update:category', categoryName);
};
</script>

<style scoped>
.left-nav-thumb-text {
    font-size: 38px;
    padding: 0px 10px;
}

.left-nav-no-image-text {
    font-size: 12px;
    font-weight: 100;
}
</style>